import {
  Flex,
  Menu,
  MenuButton,
  MenuList,
  Text,
  Button,
  Box,
} from "@chakra-ui/react"

import { useAppSelector } from "app/hooks"
import { camelCaseToDisplayText } from "components/add-tag-modal/AddTagModal"
import RoundedBadge from "components/table/rounded-badge"
import { selectCompanyTags } from "store/auth/authSlice"

const ViewTagMenu = ({ tagOrder }: { tagOrder: string[] }) => {
  const companyTagData = useAppSelector(selectCompanyTags)

  const tagDataMap = companyTagData as unknown as Record<string, boolean> | null
  const activeTags = tagDataMap
    ? Object.entries(tagDataMap).filter(
        ([key, value]) => value && tagOrder.includes(key),
      )
    : []

  return (
    <Menu autoSelect={false}>
      <MenuButton
        px='12px'
        h='30px'
        variant='secondary'
        as={Button}
        colorScheme='black'
        role='group'
        _focus={{}}
        _active={{}}
      >
        <Flex justifyContent='space-between' alignItems='center'>
          <Text
            fontWeight='500'
            fontSize='14px'
            lineHeight='10px'
            color='#006F80'
            _groupHover={{ color: "#fff" }}
          >
            View Tag
          </Text>
        </Flex>
      </MenuButton>

      <MenuList minWidth='200px' zIndex={2}>
        {activeTags.length > 0 ? (
          activeTags.map(([key]) => (
            <Box
              key={key}
              display='block'
              marginBottom={{ base: "3px", md: "10px" }}
            >
              <RoundedBadge
                marginRight='0px'
                text={camelCaseToDisplayText(key)}
              />
            </Box>
          ))
        ) : (
          <Box fontWeight={600} textAlign='center'>
            No Tag List
          </Box>
        )}
      </MenuList>
    </Menu>
  )
}

export default ViewTagMenu
